<div class="container">
  <div class="row justify-content-center">
    <div class="col-md-5 title">
      <h1 class="main-heading">INGRESO</h1>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="login-card">
      <mat-card>
        <mat-card-content>
          <p>Ingresar al Registro de Personas y Empresas con Usuario gub.uy</p>
        </mat-card-content>
        <mat-card-actions align="end">
          <rpe-ui-button [bg_blue]="true" (onClick)="idpLogin()">Siguiente</rpe-ui-button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
